intra_module.factory('features', function() {
  const stored = localStorage.getItem('features');
  const user_prefs = stored === null ? {} : JSON.parse(stored);
  
  let features = {
	filebank_enabled: user_prefs.filebank_enabled || true,
	no_log_schedules_enabled: user_prefs.no_log_schedules_enabled || true,

	setUserPref(feature_name, value) {
	  if (user_prefs[feature_name] != value) {
		user_prefs[feature_name] = value;
		localStorage.setItem('features', JSON.stringify(user_prefs));
		console.log(`Set user pref: feature ${feature_name} to ${value}`);
	  }
	}
  };

  return features;
});
